import {
  DealRecordType,
  type Payment as PaymentPayment,
  PaymentType,
} from '@marxbiotech/shared-types/bff';

import { convertToLocale } from '@lib/util/money';
import CheckoutFormItem from './checkout-form-item';

interface PaymentSectionProps {
  payment: PaymentPayment;
}

const CodSection = ({ payment }: PaymentSectionProps) => {
  const dealRecord = payment.dealRecords?.find(
    (dr) => dr.type === DealRecordType.COD_REQUEST
  );
  return (
    <>
      <CheckoutFormItem
        title="支付方式"
        value="貨到付款"
        tooltip="使用貨到付款結帳，系統將優先從您的退貨退款餘額扣除。"
        data-testid="order-detail-payment-method"
      />
      <CheckoutFormItem
        title="退貨退款餘額"
        value={convertToLocale({
          amount: dealRecord?.codRefundBalance ?? 0,
          currency_code: 'twd',
        })}
      />
      <CheckoutFormItem
        title="待支付貨款"
        value={convertToLocale({
          amount: dealRecord?.codOutstandingDifference ?? 0,
          currency_code: 'twd',
        })}
        tooltip="＝ 訂單總金額 - 使用的退貨退款金額"
        valueClassName="font-bold"
      />
    </>
  );
};

const DepositSection = ({ payment }: PaymentSectionProps) => {
  const dealRecord = payment.dealRecords?.find(
    (dr) => dr.type === DealRecordType.CHARGE
  );
  return (
    <>
      <CheckoutFormItem title="支付方式" value="使用儲值金" data-testid="order-detail-payment-method" />
      <CheckoutFormItem
        title="總儲值金餘額"
        value={convertToLocale({
          amount:
            (dealRecord?.cashBalance ?? 0) +
            (dealRecord?.rewardBalance ?? 0) +
            (dealRecord?.refundBalance ?? 0),
          currency_code: 'twd',
        })}
        tooltip="＝ 儲值金 + 儲值回饋金 + 退貨回饋金"
        valueClassName="font-bold"
      />
    </>
  );
};

const DepositWithLoanSection = ({ payment }: PaymentSectionProps) => {
  const dealRecord = payment.dealRecords?.find(
    (dr) => dr.type === DealRecordType.CHARGE
  );
  return (
    <>
      <CheckoutFormItem title="支付方式" value="使用儲值金 + 賒帳" data-testid="order-detail-payment-method" />
      <CheckoutFormItem
        title="總儲值金餘額"
        value={convertToLocale({
          amount:
            (dealRecord?.cashBalance ?? 0) +
            (dealRecord?.rewardBalance ?? 0) +
            (dealRecord?.refundBalance ?? 0),
          currency_code: 'twd',
        })}
        tooltip="＝ 儲值金 + 儲值回饋金 + 退貨回饋金"
        valueClassName="font-bold"
      />
      <CheckoutFormItem
        title="欲賒帳金額"
        value={convertToLocale({
          amount: payment.amount - (dealRecord?.amount ?? 0),
          currency_code: 'twd',
        })}
        valueClassName="font-bold"
      />
    </>
  );
};

export const PaymentSection = ({ payment }: PaymentSectionProps) => {
  const paymentType = payment.type;
  switch (paymentType) {
    case PaymentType.COD:
      return <CodSection payment={payment} />;
    case PaymentType.DEPOSIT:
      return <DepositSection payment={payment} />;
    case PaymentType.DEPOSIT_WITH_LOAN:
      return <DepositWithLoanSection payment={payment} />;
    default:
      console.error(`Unsupported payment type: ${paymentType}`);
      return null;
  }
};

export default PaymentSection;
